/**
 * Global Listeners Class
 * Handles site-wide event listeners and utilities
 *
 * Global Utilities:
 * - window.QF.initDragScroll(selector) - Adds drag-to-scroll functionality to any horizontal scrolling container
 *   Usage: window.QF.initDragScroll('.tabs ul') or window.QF.initDragScroll('.fmf-modal .tabs ul')
 */
class GlobalListeners {
  constructor() {
    this.selectors = {
      quickAdds: '[quick-add-qf]',
      productForms: '[action="/cart/add"]:not(.ctl-product-form [action="/cart/add"])',
      openSideCart: '.openSideCart',
      closeSideCart: '.closeSideCart',
      itemCard: '.cart .items-wrapper .item',
      removeButtons: '.cart .items-wrapper .remove-item',
      quantitySelectorPlus: '.cart .items-wrapper .quantity-wrapper .plus',
      quantitySelectorMinus: '.cart .items-wrapper .quantity-wrapper .minus',
      cartCount: '.cart-count',
      giftAddToCarts: '[qf-gift-add-to-cart]',
      predictiveSearch: '.predictive-search-container',
    };

    this.init();
    this.initGlobalUtilities();
  }

  init() {
    window.log("Initializing global QF listeners");
    document.body.addEventListener('click', this.handleEvent.bind(this));
    // document.body.addEventListener('change', (e)=>{
    //   if(e.target.closest('[data-change-sub]')){
    //     (async ()=>{
    //       var key = e.target.closest('[data-change-sub]').getAttribute('data-change-sub')
    //       await window.cart.change({
    //         id: key,
    //         selling_plan: parseInt(e.target.value),
    //         properties: {_selling_plan:parseInt(e.target.value)}
    //       })
    //     })()
    //   }
    // });
    document.body.addEventListener('change', (e)=>{
      if(e.target.closest('[data-change-sub]')){
        (async ()=>{
          var key = e.target.closest('[data-change-sub]').getAttribute('data-change-sub');
          var quantityWrapper = e.target.closest('.item').querySelector('.quantity-wrapper');
          var quantity = 1;
          if (quantityWrapper) {
            var quantitySpan = quantityWrapper.querySelector('.quantity span');
            if (quantitySpan) {
              quantity = parseInt(quantitySpan.textContent.trim(), 10) || 1;
            }
          }
          await window.cart.change({
            id: key,
            quantity: quantity,
            selling_plan: parseInt(e.target.value),
            properties: {_selling_plan:parseInt(e.target.value)}
          })
        })()
      }
    });
    this.productForm();
    this.cartRelated();
    this.headerSearch();
    this.mobileMenu();
    this.sideCartTabs();
    this.openFmfModal();
    this.giftAddToCart();
    this.showBabPromotionBanner();
    this.initProductCardFeedingMessages();

    // Check scroll
    function checkScroll() {
      const scrollPosition = window.scrollY;

      if (scrollPosition > 30) {
        document.body.classList.add('scrolled');
      } else {
        document.body.classList.remove('scrolled');
      }
    }
    window.addEventListener('scroll', checkScroll);
  }

  // handleEvent(e) {
  //   this.productQuickAdd(e);
  //   this.siteCart(e);
  //   this.quantityButtons(e);
  //   this.removeCartItem(e);
  //   if(e.target.closest('[data-swap-prod]')){
  //     (async ()=>{
  //       var json = JSON.parse(e.target.closest('[data-swap-prod]').getAttribute('data-swap-prod'))
  //       var item = {
  //         id: json[1],
  //         quantity: json[2],
  //       }
  //       if(json[3] != ''){
  //         item.selling_plan = parseInt(json[3])
  //         item.properties = {_selling_plan:json[3]}
  //       }
  //       await window.cart.remove(json[0])
  //       await window.cart.add({
  //         items: [item]
  //       })
  //     })()
  //   }
  //   if(e.target.closest('[data-apply-sub]')){
  //     (async ()=>{
  //       var json = JSON.parse(e.target.closest('[data-apply-sub]').getAttribute('data-apply-sub'))
  //       await window.cart.change({
  //         id: json[0],
  //         selling_plan: json[1],
  //         properties: {_selling_plan:json[1]}
  //       })
  //     })()
  //   }
  // }

  handleEvent(e) {
    this.productQuickAdd(e);
    this.siteCart(e);
    this.quantityButtons(e);
    this.removeCartItem(e);

    const getCart = async () => {
      const res = await fetch('/cart.js');
      return await res.json();
    };

    if (e.target.closest('[data-swap-prod]')) {
      (async () => {
        const btn = e.target.closest('[data-swap-prod]');
        const json = JSON.parse(btn.getAttribute('data-swap-prod'));

        // Get current cart and find quantity for old item
        const cart = await getCart();
        const oldLineItem = cart.items.find(item => item.key === json[0]);
        const quantity = oldLineItem ? oldLineItem.quantity : parseInt(json[2], 10) || 1;

        const item = {
          id: json[1],
          quantity: quantity,
        };

        if (json[3] !== '') {
          item.selling_plan = parseInt(json[3]);
          item.properties = { _selling_plan: json[3] };
        }

        await window.cart.remove(json[0]);
        await window.cart.add({ items: [item] });
      })();
    }

    if (e.target.closest('[data-apply-sub]')) {
      (async () => {
        const btn = e.target.closest('[data-apply-sub]');
        const json = JSON.parse(btn.getAttribute('data-apply-sub'));

        const cart = await getCart();
        const lineItem = cart.items.find(item => item.key === json[0]);
        const quantity = lineItem ? lineItem.quantity : 1;

        await window.cart.change({
          id: json[0],
          quantity: quantity,
          selling_plan: json[1],
          properties: { _selling_plan: json[1] }
        });
      })();
    }

  }

  productQuickAdd(e) {
    // PRODUCT QUICK ADD
    const quickAdd = e.target.closest(this.selectors.quickAdds);
    if (quickAdd) {
      e.preventDefault();
      const quantity = parseInt(quickAdd.dataset.quantity);
      if (quickAdd.dataset.id && quantity > 0) {
        const item = { id: quickAdd.dataset.id, quantity };
        const compareAt = quickAdd.dataset.compareAtPrice;
        if (compareAt && compareAt !== '' && !isNaN(parseFloat(compareAt))) {
          item.properties = { "_compare_at_price": parseFloat(compareAt).toFixed(2) };
        }
        window.cart.add({ items: [item] });
      }
    }
  }

  productForm() {
    // PRODUCT FORM LISTENER
    const productForms = document.querySelectorAll(this.selectors.productForms);
    if (productForms.length > 0) {
      productForms.forEach(productForm => {
        productForm.addEventListener("submit", e => {
          e.preventDefault();
          const quantity = productForm.querySelector("input.quantity-selector").value;
          const id = productForm.querySelector("#product-id").value;

          // Check if subscription is selected
          const isSubscription = productForm.querySelector("#purchase-subscription")?.checked || false;

          // Get selling plan select element
          const sellingPlanSelect = productForm.querySelector("#selling_plan_select");

          // Helper to get compare at price based on current selection
          const getCompareAtPrice = () => {
            let detectedCompare = null;
            const selectedVariantRadio = productForm.querySelector('.variant-size-radio:checked');
            const variantId = selectedVariantRadio ? selectedVariantRadio.value : null;
            const isSub = isSubscription;
            if (!isSub) {
              if (selectedVariantRadio && selectedVariantRadio.dataset && selectedVariantRadio.dataset.variantComparePrice) {
                const val = parseFloat(selectedVariantRadio.dataset.variantComparePrice / 100);
                console.log("val", val)
                if (!isNaN(val)) detectedCompare = val.toFixed(2);
              }
              if (!detectedCompare && variantId) {
                const wasPriceEl = document.querySelector(`#one-time-price-display .variant-price-container[data-variant-id="${variantId}"] .was-price`);
                if (wasPriceEl && wasPriceEl.textContent) {
                  console.log("onetime", wasPriceEl, wasPriceEl.textContent)
                  const parsed = parseFloat(wasPriceEl.textContent.replace(/[^0-9.-]+/g, ''));
                  console.log("onetime parsed", parsed,)
                  if (!isNaN(parsed)) detectedCompare = parsed.toFixed(2);
                }
              }
            } else if (variantId) {
              const wasPriceEl = document.querySelector(`#subscription-price-display .variant-price-container[data-variant-id="${variantId}"] .was-price`);
              if (wasPriceEl && wasPriceEl.textContent) {
                const parsed = parseFloat(wasPriceEl.textContent.replace(/[^0-9.-]+/g, ''));
                if (!isNaN(parsed)) detectedCompare = parsed.toFixed(2);
              }
            }
            return detectedCompare;
          };

          // Check if we're in subscription mode and the select isn't disabled
          if (isSubscription && sellingPlanSelect && !sellingPlanSelect.disabled) {
            const sellingPlanId = sellingPlanSelect.value;

            if (quantity && id && sellingPlanId) {
              console.log('Adding subscription item:', id, quantity, sellingPlanId);

              // Add to cart with selling plan
              const cap = getCompareAtPrice();
              const props = { "_selling_plan": sellingPlanId };
              if (cap) props["_compare_at_price"] = cap;
              window.cart.add({ items: [{ id, quantity, selling_plan: sellingPlanId, properties: props }] });
            }
          } else {
            // One-time purchase
            if (quantity && id) {
              console.log('Adding one-time item:', id, quantity);
              const cap = getCompareAtPrice();
              const item = { id, quantity };
              if (cap) item.properties = { "_compare_at_price": cap };
              window.cart.add({ items: [item] });
            }
          }
        });
      });
    }
  }

  giftAddToCart() {
    const giftAddToCarts = document.querySelectorAll(this.selectors.giftAddToCarts);
    giftAddToCarts.forEach(addToCart => {
      addToCart.addEventListener("click", e => {
        e.preventDefault();

        const gift_product_ids = document.querySelectorAll(".recipient-form input[name='selected-gift-products[]']");
        const giftCartItems = [];

        const recipientName = document.querySelector(".recipient-form #recipients-name").value;
        const recipientAddress = document.querySelector(".recipient-form #recipients-address").value;
        const recipientPostcode = document.querySelector(".recipient-form #recipients-postcode").value;
        const recipientMessage = document.querySelector(".recipient-form #recipients-message").value;

        if (!recipientName || !recipientAddress || !recipientPostcode || !recipientMessage) {
          document.querySelector('.modal-form-error').textContent = 'Please fill in all the fields.';
          return;
        }

        gift_product_ids.forEach(idInput => {
          const product_id = idInput.value;
          if (product_id) {
            const giftCartItem = {
              "id": product_id,
              "quantity": 1,
              "properties": {
                "recipient_gift": "yes",
                "recipient_name": recipientName,
                "recipient_address": recipientAddress,
                "recipient_postcode": recipientPostcode,
                "recipient_message": recipientMessage
              }
            };
            giftCartItems.push(giftCartItem);
          }
        });

        // Add all the items to the cart
        if (giftCartItems.length > 0) {
          window.cart.add({ items: giftCartItems });
        }
      });
    });
  }

  siteCart(e) {
    // SITE CART OPEN AND CLOSE
    if (!window.QF.settings.sideCart) return;

    const openSideCart = e.target.closest(this.selectors.openSideCart);
    if (openSideCart) {
      e.preventDefault();
      if (!window.cart.cartOpen) {
        window.cart.openSideCart();
      }
    }

    const closeSideCart = e.target.closest(this.selectors.closeSideCart);
    const sideCartDrawer = document.querySelector('#cart-drawer-container');
    if (window.cart.cartOpen) {
      if (e.target == sideCartDrawer) {
        window.cart.closeSideCart();
      }
    }
    if (closeSideCart) {
      e.preventDefault();
      if (window.cart.cartOpen) {
        window.cart.closeSideCart();
      }
    }
  }

  quantityButtons(e) {
    // QUANTITY PLUS CART
    const quantityPlus = e.target.closest(this.selectors.quantitySelectorPlus);
    if (quantityPlus) {
      if (quantityPlus.getAttribute("data-pending") === "true") return;
      quantityPlus.setAttribute("data-pending", true);

      const quantity = quantityPlus.parentNode.querySelector(".quantity span");
      const stock = quantity.getAttribute("data-stock");
      const variant_id = quantity.getAttribute("data-variant-id");
      const inv_policy = quantity.getAttribute("data-inventory-policy");

      const current = parseInt(quantity.innerHTML);
      if (inv_policy === "continue" || stock > 0) {
        if (current > 0) {
          const updated = current + 1;
          window.cart.update({ updates: { [variant_id]: updated } }, 'plus');
        }
      }
    }

    // QUANTITY MINUS CART
    const quantityMinus = e.target.closest(this.selectors.quantitySelectorMinus);
    if (quantityMinus) {
      if (quantityMinus.getAttribute("data-pending") === "true") return;
      quantityMinus.setAttribute("data-pending", true);

      const quantity = quantityMinus.parentNode.querySelector(".quantity span");
      const current = parseInt(quantity.innerHTML);
      const variant_id = quantity.getAttribute("data-variant-id");

      if (current > 0) {
        const updated = current - 1;
        window.cart.update({ updates: { [variant_id]: updated } }, 'minus');
      }
    }
  }

  removeCartItem(e) {
    // REMOVE ITEM CART
    const itemCard = e.target.closest(this.selectors.itemCard);
    const removeButtons = e.target.closest(this.selectors.removeButtons);
    if (removeButtons) {
      const variant_id = removeButtons.getAttribute("data-variant-id");
      const product_id = itemCard.getAttribute("data-product-id");
      const quantity = itemCard.querySelector('.quantity-wrapper').getAttribute('data-quantity');
      const index = itemCard.getAttribute('data-index');
      const event = new CustomEvent('cart_item_removed', {
        detail: {
          variant_id: variant_id,
          product_id: product_id,
          quantity: quantity,
          index: index
        }
      });
      window.cart.remove(variant_id);
      window.dispatchEvent(event);
    }
  }

  cartRelated() {
    // update side cart/cart after change
    const renderCarts = () => {
      if (window.template === "cart") {
        window.cart.reRenderCart();
      } else {
        if (window.QF.settings.ajax_open_side_cart) {
          window.cart.openSideCart();
        } else if (window.QF.settings.ajax_toast) {
          window.cart.reRenderSideCart();
        }
      }
    };
    window.addEventListener("cart_changed", renderCarts);
    window.addEventListener("item_removed", renderCarts);

    // CART COUNT
    window.addEventListener("cart_changed", e => {
      if (e.detail.cart) {
        const cartCount = document.querySelectorAll(".cart-count");
        cartCount.forEach(count => {
          count.innerHTML = e.detail.cart.item_count;
        });
      }
    });
  }

  headerSearch() {
    const search = document.querySelector('.mega-menu .mega-menu-wrapper .header-search-bar-wrapper');
    const searchTrigger = document.querySelector('.mega-menu .mega-menu-controls [data-open-search]');
    const searchInput = document.querySelector('.mega-menu .mega-menu-wrapper .header-search-bar-wrapper .search-bar-qf input');
    const predictiveSearch = document.querySelector('.predictive-search-container');
    const mobileSearchClose = document.querySelector('.mobile-search-close');

    // Check Search exists
    if (search) {
      // Open / Close Search
      searchTrigger.addEventListener('click', e => {
        e.preventDefault();

        if (searchTrigger.classList.contains('active')) {
          searchTrigger.classList.remove('active');
          search.classList.remove('active');
          predictiveSearch.classList.remove('active');
          searchInput.value = '';
          document.body.classList.remove('fixed');
        } else {
          searchTrigger.classList.add('active');
          search.classList.add('active');
          searchInput.focus();
        }
      });

      // Close mobile
      mobileSearchClose.addEventListener('click', e => {
        e.preventDefault();

        searchTrigger.classList.remove('active');
        search.classList.remove('active');
        predictiveSearch.classList.remove('active');
        searchInput.value = '';
        document.body.classList.remove('fixed');
      });

      // Close search with Escape Key
      window.addEventListener('keydown', e => {
        const key = e.key;

        if (key === 'Escape') {
          if (window.activeElement.classList.contains('header-search')) {
            searchTrigger.classList.remove('active');
            search.classList.remove('active');
          } else {
            return;
          }
        }
      });
    }

  }

  mobileMenu() {
    const menu = document.querySelector('.mobile-menu-outer-wrapper');
    const menuTrigger = document.querySelector('#open-mobile-menu');
    const mobileTrigger = document.querySelector('.search-mobile');
    const searchSideBar = document.querySelector('.predictive-search-container');
    const closeMobileMenu = document.querySelector('.close-mobile-menu');

    if (menuTrigger) {
      menuTrigger.addEventListener('click', () => {

        if (menuTrigger.classList.contains('active')) {
          menu.classList.remove('active');
          menuTrigger.classList.remove('active');
          document.body.classList.remove('fixed');
        } else {
          menu.classList.add('active');
          menuTrigger.classList.add('active');
          document.body.classList.add('fixed');
        }
      });
    }
    if (mobileTrigger) {
      mobileTrigger.addEventListener('click', () => {

        if (mobileTrigger.classList.contains('active')) {
          menu.classList.remove('active');
          menuTrigger.classList.remove('active');
        } else {
          menu.classList.add('active');
          menuTrigger.classList.add('active');
        }
      });
    }
    menu.addEventListener('click', e => {
      if (e.target.classList.contains('mobile-menu-outer-wrapper')) {
        menu.classList.remove('active');
        menuTrigger.classList.remove('active');
        mobileTrigger.classList.remove('active');
        document.body.classList.remove('fixed');
      }
    });

    closeMobileMenu.addEventListener('click', e => {
      if (menuTrigger.classList.contains('active')) {
        menu.classList.remove('active');
        menuTrigger.classList.remove('active');
        mobileTrigger.classList.remove('active');
        document.body.classList.remove('fixed');
      }
      if (searchSideBar.classList.contains('active')) {
        searchSideBar.classList.remove('active');
      }
    });
  }

  sideCartTabs() {
    const cart_tabs = document.querySelectorAll('.cart-tab');

    cart_tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        tab.classList.remove('active');
        if (!e.target.closest('.cart-tab').classList.contains('active')) {
          cart_tabs.forEach(tab => {
            tab.classList.remove('active');
          })
          let tab_selected = e.target.closest('.cart-tab');
          tab_selected.classList.add('active')
          let tab_data = tab_selected.getAttribute('data-tab');
          let cart_contents = document.querySelectorAll('.cart-content');
          cart_contents.forEach(cart_content => {
            cart_content.style.display = 'none';
          })
          document.querySelector('.' + tab_data).style.display = 'flex';
          if (tab_data == 'saved-cart') {
            if (window.wishlist.needsUpdate) {
              window.wishlist.initSideCartGrid();
              window.wishlist.needsUpdate = false;
            }
          }
        }
      })
    })
  }

  openFmfModal() {
    const openButtons = document.querySelectorAll('[open-fmf-modal], a[href="#fmf-modal"]');
    let imagesLoaded = false;

    const loadFmfSection = () => {
      if (this.fmfSectionPromise) return this.fmfSectionPromise;

      const existingModal = document.querySelector('find-my-food-modal');
      if (existingModal) {
        this.cacheFmfElements(existingModal);
        return Promise.resolve(existingModal);
      }

      this.fmfSectionPromise = fetch('/?section_id=fg-find-my-food-modal')
        .then((res) => res.text())
        .then((html) => {
          const wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          const sectionEl = wrapper.querySelector('find-my-food-modal');

          if (sectionEl) {
            document.body.appendChild(sectionEl);
            this.cacheFmfElements(sectionEl);
            // Execute any scripts included in the section markup (e.g., Litepicker and FMF bundle)
            const scripts = sectionEl.querySelectorAll('script');
            scripts.forEach((oldScript) => {
              const newScript = document.createElement('script');
              if (oldScript.src) {
                newScript.src = oldScript.src;
              } else {
                newScript.textContent = oldScript.textContent;
              }
              document.body.appendChild(newScript);
            });
          }
          return sectionEl;
        })
        .catch((err) => {
          console.error('Failed to load FMF section', err);
          return null;
        });

      return this.fmfSectionPromise;
    };

    const openModal = (trigger) => {
      if (!this.fmfModal || !this.fmfModalTab) return;

      if (!imagesLoaded) {
        const images = this.fmfModal.querySelectorAll('img[data-src]');
        images.forEach((image) => {
          const src = image.getAttribute('data-src');
          image.setAttribute('src', src);
          image.removeAttribute('data-src');
        });
        imagesLoaded = true;
      }

      const openModalText = trigger?.getAttribute?.('data-title') || 'Feeding Advice';
      document.body.classList.toggle('fixed');
      this.fmfModal.classList.toggle('active');
      if (this.fmfModalTab.innerHTML == "Close") {
        this.fmfModalTab.innerHTML = openModalText;
      } else {
        this.fmfModalTab.innerHTML = "Close";
      }
    };

    const ensureCloseHandler = () => {
      if (!this.fmfCloseButton || this.fmfCloseBound) return;
      this.fmfCloseButton.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.remove('fixed');
        this.fmfModal.classList.remove('active');
        this.fmfModalTab.innerHTML = "Feeding Advice";
      });
      this.fmfCloseBound = true;
    };

    const handleOpenClick = async (trigger) => {
      const sectionLoaded = await loadFmfSection();
      if (!sectionLoaded) return;
      ensureCloseHandler();
      openModal(trigger);
    };

    openButtons.forEach((open) => {
      open.addEventListener('click', (e) => {
        e.preventDefault();
        handleOpenClick(open);
      });
    });

    // Section render and script load now occur only after an explicit button click
  }

  cacheFmfElements(sectionEl) {
    this.fmfModal = sectionEl.querySelector('.fmf-modal');
    this.fmfModalTab = sectionEl.querySelector('.fmf-modal .open-fmf');
    this.fmfCloseButton = sectionEl.querySelector('.fmf-modal .close-modal');
  }

  showBabPromotionBanner() {
    if(window.QF.has_had_subscription === false) {
      const babPromotionBanner = document.querySelector('.promotional-bar .promo-bar-content');
      if(babPromotionBanner){
        const babPromotionBannerText = babPromotionBanner.querySelector('.promo-bar-text');
        const babPromotionBannerLink = babPromotionBanner.querySelector('.promo-bar-link');

        const babQualifyOffer = localStorage.getItem('babQualifyOffer');
        const babStage = localStorage.getItem('babStage');

        if (babQualifyOffer === 'true') {
          babPromotionBanner.style.display = 'block';

          if (window.template === 'page.build-a-box') {
            if (babPromotionBannerLink) {
              babPromotionBannerLink.href = '/';
              babPromotionBannerText.innerHTML = 'Take me back to the main site';
            } else {
              babPromotionBannerText.innerHTML = `<a href="/">Take me back to the main site</a>`;
            }
          } else {
            let babUrl = '/pages/build-a-box';
            const babId = localStorage.getItem('babId');
            if (babStage === 'bab-landing') {
              babUrl = '/pages/build-a-box-landing';
            } else if (babStage === 'bab-recommendations') {
              if(babId) {
                babUrl = `/pages/build-a-box?dogId=${babId}`;
              } else {
                babUrl = '/pages/build-a-box';
              }
            }
            if (babPromotionBannerLink) {
              babPromotionBannerLink.href = babUrl;
              babPromotionBannerText.innerHTML = `Unlock our latest offer - Save ${window.QF.buildABox.firstBoxValue}%, ${window.QF.buildABox.secondBoxValue}%, ${window.QF.buildABox.thirdBoxValue}% off Subscriptions`;
            } else {
              babPromotionBannerText.innerHTML = `<a href="${babUrl}">Unlock our latest offer - Save ${window.QF.buildABox.firstBoxValue}%, ${window.QF.buildABox.secondBoxValue}%, ${window.QF.buildABox.thirdBoxValue}% off Subscriptions</a>`;
            }
          }
        }
      }
    }
  }

  parsePositiveNumber(value) {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const normalizedValue = String(value).replace(/,/g, '.').trim();
    const parsedNumber = Number(normalizedValue);
    if (!Number.isFinite(parsedNumber) || parsedNumber <= 0) {
      return null;
    }

    return parsedNumber;
  }

  getStoredJSON(key, fallbackValue) {
    try {
      const rawValue = localStorage.getItem(key);
      if (!rawValue) {
        return fallbackValue;
      }

      const parsedValue = JSON.parse(rawValue);
      return parsedValue ?? fallbackValue;
    } catch (error) {
      return fallbackValue;
    }
  }

  getDogAgeFromDob(dogDob = '') {
    if (!dogDob) return '';

    const today = new Date();
    const birthDate = new Date(dogDob);
    if (Number.isNaN(birthDate.getTime())) {
      return '';
    }

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age -= 1;
    }

    if (age >= 1 && age <= 7) return '1-7 years adult';
    if (age >= 8) return '7+ senior';
    if (age < 1) return '8 - 52 weeks puppy';
    return '';
  }

  normalizeLifestage(value = '') {
    const normalizedValue = String(value || '').trim().toLowerCase();
    if (normalizedValue.includes('puppy')) return 'puppy';
    if (normalizedValue.includes('senior')) return 'senior';
    if (normalizedValue.includes('adult')) return 'adult';
    return '';
  }

  normalizeLifestages(value = '') {
    const normalizedValue = String(value || '').trim().toLowerCase();
    const lifestages = [];

    if (normalizedValue.includes('puppy')) lifestages.push('puppy');
    if (normalizedValue.includes('adult')) lifestages.push('adult');
    if (normalizedValue.includes('senior')) lifestages.push('senior');

    return lifestages;
  }

  getDogLifestageForData(dogData = {}) {
    return this.normalizeLifestage(dogData.dog_age || this.getDogAgeFromDob(dogData.dog_dob));
  }

  isProductSuitableForDogLifestage(productStages = '', dogLifestage = '') {
    const normalizedDogLifestage = this.normalizeLifestage(dogLifestage);
    const normalizedProductStages = String(productStages || '')
      .split(',')
      .flatMap((stage) => this.normalizeLifestages(stage))
      .filter(Boolean);

    if (!normalizedDogLifestage || normalizedProductStages.length === 0) {
      return true;
    }

    return normalizedProductStages.includes(normalizedDogLifestage);
  }

  getWeightArray(weight) {
    if (weight > 1 && weight <= 6) {
      return [36.92, 43.57];
    } else if (weight > 6 && weight <= 15) {
      return [36.86, 48.22];
    } else if (weight > 15 && weight <= 27) {
      return [39.88, 60.7];
    } else if (weight > 27 && weight <= 47) {
      return [36.96, 56.18];
    } else if (weight > 47) {
      return [36.61, 62.39];
    }

    return [36.92, 43.57];
  }

  calculatePuppyDailyKcal(dogDobValue, dogWeightValue) {
    const inputAge = new Date(dogDobValue);
    const dogWeight = Number(dogWeightValue);
    if (Number.isNaN(inputAge.getTime()) || !Number.isFinite(dogWeight) || dogWeight <= 0) {
      return null;
    }

    const diffWeeks = Math.floor((new Date() - inputAge) / (7 * 24 * 60 * 60 * 1000));
    const lnWeeks = Math.log(Math.max(diffWeeks, 1));
    const weightArray = this.getWeightArray(dogWeight);
    const percentFinalAdult = ((weightArray[0] * lnWeeks) - weightArray[1]) / 100;
    const effectiveWeight = dogWeight * percentFinalAdult;

    if (!Number.isFinite(effectiveWeight) || effectiveWeight <= 0) {
      return null;
    }

    const kcalRequirement = (254.1 - 135 * (effectiveWeight / dogWeight)) * Math.pow(effectiveWeight, 0.75);
    if (!Number.isFinite(kcalRequirement) || kcalRequirement <= 0) {
      return null;
    }

    return Math.round(kcalRequirement);
  }

  calculateDailyKcalForDogData(dogData = {}) {
    const dogWeight = Number(dogData.dog_weight_current);
    if (!Number.isFinite(dogWeight) || dogWeight <= 0) {
      return null;
    }

    const feedingJSON = window?.QF?.feedingCalculations?.weight_grouping;
    if (!feedingJSON) {
      return null;
    }

    const dogAge = dogData.dog_age || this.getDogAgeFromDob(dogData.dog_dob);
    if (!dogAge) {
      return null;
    }

    if (dogAge === '8 - 52 weeks puppy') {
      return this.calculatePuppyDailyKcal(dogData.dog_dob, dogWeight);
    }

    let activityIndex = 0;
    if (dogAge !== '7+ senior') {
      switch (dogData.dog_activity) {
        case 'lightly_active':
          activityIndex = 1;
          break;
        case 'active':
          activityIndex = 2;
          break;
        case 'sedentary':
        default:
          activityIndex = 0;
          break;
      }
    }

    const adjustedWeightIndex = Math.max(0, Math.round(dogWeight) - 1);
    const baseKcal = Number(feedingJSON?.['activity-age']?.[activityIndex]?.['weight-food']?.[adjustedWeightIndex]?.['kcal-required']);
    if (!Number.isFinite(baseKcal) || baseKcal <= 0) {
      return null;
    }

    return Math.round(baseKcal);
  }

  resolveActiveDogContext() {
    const urlParams = new URLSearchParams(window.location.search);
    const urlDogId = this.parsePositiveNumber(urlParams.get('dogId'));
    const urlDailyKcal = this.parsePositiveNumber(urlParams.get('dogDailyKcal'));
    const activeDogIdStorageKey = 'active_recommendation_dog_id';
    const activeDogDailyKcalStorageKey = 'active_recommendation_dog_daily_kcal';
    const previousDogId = this.parsePositiveNumber(
      localStorage.getItem(activeDogIdStorageKey) || sessionStorage.getItem(activeDogIdStorageKey)
    );

    if (urlDogId) {
      if (!previousDogId || Math.round(previousDogId) !== Math.round(urlDogId)) {
        localStorage.removeItem(activeDogDailyKcalStorageKey);
      }
      localStorage.setItem(activeDogIdStorageKey, String(Math.round(urlDogId)));
    }
    if (urlDailyKcal) {
      localStorage.setItem(activeDogDailyKcalStorageKey, String(Math.round(urlDailyKcal)));
    }

    const storedDogIdRaw = localStorage.getItem(activeDogIdStorageKey) || sessionStorage.getItem(activeDogIdStorageKey);
    const storedDailyKcalRaw = localStorage.getItem(activeDogDailyKcalStorageKey) || sessionStorage.getItem(activeDogDailyKcalStorageKey);
    const storedDogId = this.parsePositiveNumber(storedDogIdRaw);
    const storedDailyKcal = this.parsePositiveNumber(storedDailyKcalRaw);

    if (!localStorage.getItem(activeDogIdStorageKey) && sessionStorage.getItem(activeDogIdStorageKey)) {
      localStorage.setItem(activeDogIdStorageKey, sessionStorage.getItem(activeDogIdStorageKey));
    }
    if (!localStorage.getItem(activeDogDailyKcalStorageKey) && sessionStorage.getItem(activeDogDailyKcalStorageKey)) {
      localStorage.setItem(activeDogDailyKcalStorageKey, sessionStorage.getItem(activeDogDailyKcalStorageKey));
    }

    const fallbackDogId = this.parsePositiveNumber(window?.QF?.dogId);
    const activeDogId = urlDogId || storedDogId || fallbackDogId;

    const passportDogs = this.getStoredJSON('passport', []);
    const passportData = Array.isArray(passportDogs) ? passportDogs : [];
    const fmfData = this.getStoredJSON('FMF', {});
    const normalizedPassportData = passportData
      .map((dog) => this.normalizeDogDataForDailyKcal(dog))
      .filter((dog) => this.parsePositiveNumber(dog?.id));
    const normalizedFmfData = this.normalizeDogDataForDailyKcal(
      fmfData && typeof fmfData === 'object' ? fmfData : {}
    );

    let dogData = null;

    if (activeDogId) {
      dogData = normalizedPassportData.find((dog) => Number(dog?.id) === Math.round(activeDogId)) || null;
    }

    if (!dogData && Object.keys(normalizedFmfData).length > 0) {
      if (!activeDogId || Number(normalizedFmfData.id) === Math.round(activeDogId)) {
        dogData = normalizedFmfData;
      }
    }

    const fallbackDogData = dogData || normalizedFmfData;
    const fmfMatchesActiveDog = !activeDogId || Number(normalizedFmfData?.id) === Math.round(activeDogId);
    const fmfDailyKcal = fmfMatchesActiveDog ? this.parsePositiveNumber(normalizedFmfData?.dog_daily_kcal) : null;
    const dogDataDailyKcal = this.parsePositiveNumber(dogData?.dog_daily_kcal);
    const calculatedDogDailyKcal = this.calculateDailyKcalForDogData(fallbackDogData);
    const persistedDailyKcal = storedDogId && activeDogId && Math.round(storedDogId) === Math.round(activeDogId)
      ? storedDailyKcal
      : null;
    const dogDailyKcal = urlDailyKcal
      || fmfDailyKcal
      || dogDataDailyKcal
      || calculatedDogDailyKcal
      || persistedDailyKcal;
    const dogFoodPreference = fallbackDogData?.dog_preferences || '';
    const dogLifestage = this.getDogLifestageForData(fallbackDogData);

    if (dogDailyKcal) {
      localStorage.setItem(activeDogDailyKcalStorageKey, String(Math.round(dogDailyKcal)));
    } else {
      localStorage.removeItem(activeDogDailyKcalStorageKey);
    }

    return {
      dogDailyKcal: dogDailyKcal ? Math.round(dogDailyKcal) : null,
      dogFoodPreference,
      dogLifestage,
    };
  }

  normalizeDogDataForDailyKcal(rawDogData = {}) {
    if (!rawDogData || typeof rawDogData !== 'object') {
      return {};
    }

    return {
      id: rawDogData.id || rawDogData['dogs[0][id]'],
      dog_dob: rawDogData.dog_dob || rawDogData['dogs[0][dog_dob]'],
      dog_age: rawDogData.dog_age || rawDogData['dogs[0][dog_age]'],
      dog_weight_current: rawDogData.dog_weight_current || rawDogData['dogs[0][dog_weight_current]'],
      dog_activity: rawDogData.dog_activity || rawDogData['dogs[0][dog_activity]'],
      dog_daily_kcal: rawDogData.dog_daily_kcal || rawDogData['dogs[0][dog_daily_kcal]'],
      dog_preferences: rawDogData.dog_preferences || rawDogData['dogs[0][dog_preferences]'] || rawDogData.find_my_food_preferences,
    };
  }

  isMixedWetDryPreference(preferenceValue = '') {
    const normalizedValue = String(preferenceValue || '').trim().toLowerCase();
    return normalizedValue === 'dog-feeding-mix'
      || normalizedValue === 'mix'
      || normalizedValue === 'mixture of wet and dry';
  }

  updateRecommendationContextFromDogData(rawDogData = {}) {
    const dogData = this.normalizeDogDataForDailyKcal(rawDogData);
    const dogId = this.parsePositiveNumber(dogData.id);
    const dogDailyKcal = this.parsePositiveNumber(dogData.dog_daily_kcal) || this.calculateDailyKcalForDogData(dogData);
    const activeDogIdStorageKey = 'active_recommendation_dog_id';
    const activeDogDailyKcalStorageKey = 'active_recommendation_dog_daily_kcal';

    if (dogId) {
      localStorage.setItem(activeDogIdStorageKey, String(Math.round(dogId)));
    }

    if (dogDailyKcal) {
      localStorage.setItem(activeDogDailyKcalStorageKey, String(Math.round(dogDailyKcal)));
    }
  }

  renderProductCardFeedingAmounts(scope = document) {
    const { dogDailyKcal, dogFoodPreference, dogLifestage } = this.resolveActiveDogContext();
    const cardElements = scope.classList?.contains('product-card')
      ? [scope]
      : scope.querySelectorAll('.product-card[data-cen-kcal-100g]');

    cardElements.forEach((productCard) => {
      const feedingMessage = productCard.querySelector('[data-product-feeding-grams]');
      if (!feedingMessage) {
        return;
      }

      const productKcalPer100g = this.parsePositiveNumber(productCard.getAttribute('data-cen-kcal-100g'));
      const productStages = productCard.getAttribute('data-stage') || '';
      const isSuitableForDogLifestage = this.isProductSuitableForDogLifestage(productStages, dogLifestage);

      if (!dogDailyKcal || !productKcalPer100g || !isSuitableForDogLifestage) {
        feedingMessage.textContent = '';
        feedingMessage.hidden = true;
        return;
      }

      const calculatedGramsPerDay = (dogDailyKcal / productKcalPer100g) * 100;
      const isMixedWetDry = this.isMixedWetDryPreference(dogFoodPreference);
      const gramsPerDay = Math.round(
        isMixedWetDry
          ? (calculatedGramsPerDay / 2)
          : calculatedGramsPerDay
      );
      if (!Number.isFinite(gramsPerDay) || gramsPerDay <= 0) {
        feedingMessage.textContent = '';
        feedingMessage.hidden = true;
        return;
      }

      feedingMessage.textContent = isMixedWetDry
        ? `Approx. ${gramsPerDay}g/day for 50% of this product`
        : `Approx. ${gramsPerDay}g/day for this product`;
      feedingMessage.hidden = false;
    });
  }

  initProductCardFeedingMessages() {
    if (this.productCardFeedingInitialized) {
      return;
    }
    this.productCardFeedingInitialized = true;

    window.QF = window.QF || {};
    window.QF.renderProductCardFeedingAmounts = (scope = document) => this.renderProductCardFeedingAmounts(scope);
    window.QF.updateRecommendationContextFromDogData = (dogData = {}) => this.updateRecommendationContextFromDogData(dogData);

    this.renderProductCardFeedingAmounts(document);

    const refreshProductCardFeedingMessage = (dogData = {}) => {
      this.updateRecommendationContextFromDogData(dogData);
      this.renderProductCardFeedingAmounts(document);
    };

    window.addEventListener('find_my_food', (event) => {
      refreshProductCardFeedingMessage(event.detail || {});
    });

    window.addEventListener('pet_passport', (event) => {
      refreshProductCardFeedingMessage(event.detail || {});
    });

    window.addEventListener('storage', (event) => {
      if (event.key === 'FMF' || event.key === 'passport') {
        this.renderProductCardFeedingAmounts(document);
      }
    });

    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;

          const productCards = node.classList?.contains('product-card')
            ? [node]
            : Array.from(node.querySelectorAll?.('.product-card') || []);

          productCards.forEach((productCard) => {
            this.renderProductCardFeedingAmounts(productCard);
          });
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    this.productCardFeedingObserver = observer;
  }

  // Initialize global utility functions
  initGlobalUtilities() {
    // Global drag scroll utility
    window.QF = window.QF || {};
    window.QF.initDragScroll = (selector) => {
      const tabsList = document.querySelector(selector);
      if (!tabsList) return;

      let isDragging = false;
      let startX, scrollLeft;
      let animationId;
      let dragDistance = 0;
      let startTime;
      let hasDragged = false;
      let dragStartTarget = null;

      const startDragging = (e) => {
        // Don't start dragging on specific interactive elements which should be a click
        if (e.target.closest('[data-create-tab], button:not(.tab-link), a, input, select, textarea')) {
          return;
        }

        isDragging = true;
        hasDragged = false;
        dragStartTarget = e.target;
        startX = e.type === 'mousedown' ? e.pageX - tabsList.offsetLeft : e.touches[0].pageX - tabsList.offsetLeft;
        scrollLeft = tabsList.scrollLeft;
        dragDistance = 0;
        startTime = Date.now();

        tabsList.classList.add('dragging');
      };

      const stopDragging = () => {
        isDragging = false;
        tabsList.classList.remove('dragging');

        if (animationId) {
          cancelAnimationFrame(animationId);
        }

        // Reset drag state after a short delay to allow for click events
        setTimeout(() => {
          hasDragged = false;
          dragDistance = 0;
          dragStartTarget = null;
        }, 200);
      };

      const drag = (e) => {
        if (!isDragging) return;

        const x = e.type === 'mousemove' ? e.pageX - tabsList.offsetLeft : e.touches[0].pageX - tabsList.offsetLeft;
        const walk = x - startX;
        dragDistance = Math.abs(walk);

        // Only prevent default and scroll if we've moved enough to be considered dragging
        if (dragDistance > 8) {
          hasDragged = true;
          e.preventDefault();

          // Use requestAnimationFrame for smooth scrolling
          if (animationId) {
            cancelAnimationFrame(animationId);
          }

          animationId = requestAnimationFrame(() => {
            tabsList.scrollLeft = scrollLeft - walk;
          });
        }
      };

      // Handle click events to prevent selection during drag
      const handleClick = (e) => {
        // Don't prevent clicks on specific interactive elements that should always work
        if (e.target.closest('[data-create-tab], button:not(.tab-link), a, input, select, textarea')) {
          return;
        }

        // Check if we're clicking on a tab link and if we've been dragging
        // For function new-find-my-food.js and passports.js
        // Can add more if needed
        const isTabClick = e.target.closest('[data-change-tab]');

        if (isTabClick && hasDragged && dragDistance > 12) {
          // console.log('Preventing tab switch due to drag:', { dragDistance, hasDragged });
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      };

      // Mouse events
      tabsList.addEventListener('mousedown', startDragging);
      document.addEventListener('mousemove', drag);
      document.addEventListener('mouseup', stopDragging);

      // Touch events for mobile
      tabsList.addEventListener('touchstart', startDragging, { passive: false });
      document.addEventListener('touchmove', drag, { passive: false });
      document.addEventListener('touchend', stopDragging);

      // Prevent default drag behavior on images
      tabsList.addEventListener('dragstart', (e) => e.preventDefault());

      // Add click handler to prevent selection during drag
      tabsList.addEventListener('click', handleClick, true);

      // Set initial drag-scroll class
      tabsList.classList.add('drag-scroll');
    };
  }
}

window.GlobalListeners = GlobalListeners;
